import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25NotificationsComponent } from "./s25.notifications.component";

@NgModule({
    declarations: [S25NotificationsComponent],
    imports: [CommonModule, FormsModule, S25IconComponent],
    exports: [S25NotificationsComponent],
})
export class S25NotificationsModule {}
